import {
  ADDRESS_BOOK_CONTACT_FETCH_STARTED,
  ADDRESS_BOOK_CONTACT_FETCH_SUCCEEDED,
  ADDRESS_BOOK_CONTACT_FETCH_FAILED,
  ADDRESS_BOOK_CONTACT_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  contact: {},
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADDRESS_BOOK_CONTACT_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case ADDRESS_BOOK_CONTACT_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        contact: action.payload
      };
    case ADDRESS_BOOK_CONTACT_FETCH_FAILED:
      return { ...state, status: statuses.failed, contact: {}, error: action.error };
    case ADDRESS_BOOK_CONTACT_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
